import React, { useContext, useEffect, useState } from "react";
import { Button, Icon } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import { Document, Page, pdfjs } from "react-pdf";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { b64toBlob } from "../../../app/util/base64toBlob";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface IProps {
  id: string;
}

const GraphicRepresentation: React.FC<IProps> = ({ id }) => {
  const rootStore = useContext(RootStoreContext);
  const {
    getPDFById,
    pdf,
    loadPDF,
    invoice,
  } = rootStore.invoiceStore;
  const { getRejectionConcepts } = rootStore.listOfValours;

  useEffect(() => {
    getPDFById(id);
    getRejectionConcepts();
  }, [getPDFById, id, getRejectionConcepts]);

  const downloadHandle = () => {
    const blob = b64toBlob(pdf, "application/pdf");
    const blobUrl = URL.createObjectURL(blob);
    let a = document.createElement("a");
    a.href = blobUrl;
    a.download = `${invoice.erpDocumentId}.pdf`;
    a.click();
  };

  const [numPages, setNumPages] = useState(1);

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };

  if (!loadPDF) {
    return <LoadingComponent content="Cargando PDF" />;
  }
  return (
    <div>
      <Button
        color="blue"
        onClick={downloadHandle}
        disabled={pdf === null ? true : false}
      >
        <Icon name="download" />
        Descargar
      </Button>      
      <br />
      <br />
      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          overflowY: "auto",
          overflowX: "auto",
        }}
      >
        <Document
          loading="Cargando"
          error={
            <div className="noPdfDiv"> 
              <span>El documento no tiene un PDF asociado</span>
            </div>
          }
          onLoadSuccess={onDocumentLoadSuccess}
          file={`data:application/pdf;base64,${pdf}`}
        >
          {Array.from(new Array(numPages), (el, index) => (
            <Page
              scale={1.5}
              key={`page_${index + 1}`}
              pageNumber={index + 1}
            />
          ))}
        </Document>
      </div>
    </div>
  );
};

export default observer(GraphicRepresentation);
